/* eslint-disable */

import { JsonRpcChannel } from './channel';
import { JsonRpcMessage } from "./message";

const jsonRpcCallHandlerSymbol = Symbol("jrpc.call-handler");

const jsonRpcNotifyHandlerSymbol = Symbol("jrpc.notify-handler");

interface JrpcNotifyHandlerOptions { publish: boolean }

interface JrpcNotifyHandlerMetadata {
    callback: Function;
    options: JrpcNotifyHandlerOptions;
}

export const JsonRpcCallHandler = (method: string) => (target: object, propertyName: string, descriptor: PropertyDescriptor) => {
    if (!Reflect.has(target, jsonRpcCallHandlerSymbol)) {
        Reflect.defineProperty(target, jsonRpcCallHandlerSymbol, { value: new Map<string, Function>() });
    }

    const handlers: Map<string, Function> = Reflect.get(target, jsonRpcCallHandlerSymbol);
    handlers.set(method, descriptor.value);

    return descriptor;
}

export const JsonRpcNotifyHandler =
    (method: string, options: JrpcNotifyHandlerOptions = { publish: true }) =>
        (target: object, propertyName: string, descriptor: PropertyDescriptor) => {
            if (!Reflect.has(target, jsonRpcNotifyHandlerSymbol)) {
                Reflect.defineProperty(target, jsonRpcNotifyHandlerSymbol, { value: new Map<string, JrpcNotifyHandlerMetadata>() });
            }

            const handlers: Map<string, JrpcNotifyHandlerMetadata> = Reflect.get(target, jsonRpcNotifyHandlerSymbol);
            handlers.set(method, {
                callback: descriptor.value,
                options,
            });

            return descriptor;
        }

export class JsonRpcModule {
    private channel_: JsonRpcChannel;

    constructor(channel: JsonRpcChannel) {
        this.channel_ = channel;

        if (Reflect.has(this, jsonRpcCallHandlerSymbol)) {
            const handlers: Map<string, Function> = Reflect.get(this, jsonRpcCallHandlerSymbol);

            handlers.forEach((callback, method) => {
                window.jrpc.on(method, callback);
            });
        }

        if (Reflect.has(this, jsonRpcNotifyHandlerSymbol)) {
            const handlers: Map<string, JrpcNotifyHandlerMetadata> = Reflect.get(this, jsonRpcNotifyHandlerSymbol);

            handlers.forEach((metadata, method) => {
                window.jrpc.on(method, (...args) => {
                    const { callback, options } = metadata;

                    callback.call(this, ...args);

                    if (options.publish) {
                        this.channel.publish(new JsonRpcMessage(method, args))
                    }
                });
            });
        }
    }

    get channel() { return this.channel_ }
}
